import React from 'react'

export const ChangePassword = () => {
  return (
    <div>ChangePassword</div>
  )
}
